import React, { Suspense, useEffect, useState, useRef } from "react"
import { Outlet,useLocation } from "react-router-dom"
import api from './api'
import { lang, getTextSize, cookies, img_url, page_url } from './lang'
import Footer from './Footer'
import ScrollToTop from './ScrollToTop';
import layout from '../assets/css/layout.module.css';
import footer_styles from '../assets/css/footer.module.css';
import CookieBanner from './CookieBanner';  
import Preloader from './Template/Preloader'
import Menu from './Template/NavMenu';
import { FaSearch } from "react-icons/fa";
// import ReactGA, { GA4 } from "react-ga4";

const Layout = () => {
    const [menus, setMenus] = useState([]);
    const [init, setInit] = useState([]);
    const [language, setLang] = useState("th");
    const [font_size, setFontSize] = useState("small");
    const [mobile_menu, setMobileMenu] = useState(false);
    const [chk_menu, setChkMenu] = useState(1);
    const [header_color, setHeaderColor] = useState("#fff");
    const [header_font, setHeaderFont] = useState("saruns");
    const [body_font, setBodyFont] = useState("kanit");
    const [bg_color, setBGColor] = useState("#fff");
    const location = useLocation();
    const header_ref = useRef(null);
    const body_ref = useRef(null);
  
    const [search_type, setSearchType] = useState('search website');
    const [keyword, setKeyword] = useState('');

    useEffect(()=>{
        setLang(prev => localStorage.getItem("lang"));
        const fetchMenus = async () =>{
          try {
            let data = {
              type: "%main-menu%",
              order: "parent_menu_id,order asc"
            }
            const response = await api.post('/menu',data);
            let menu = [];
            let menu_index = [];
            response.data.results.forEach(item => {
                if(!menu_index.includes(item.id)){
                  menu_index.push(item.id);
                }
                let menu_active = false;
                if(location.pathname===item.link){
                  menu_active = true;
                  if(menu[menu_index.indexOf(item.parent_menu_id)]){
                    menu[menu_index.indexOf(item.parent_menu_id)].active = true;
                  }
                }
                if(item.parent_menu_id==="0"){
                  menu[menu_index.indexOf(item.id)] = {
                    menu_id: item.id,
                    menu_th: item.menu_th,
                    menu_en: item.menu_en,
                    link: item.link,
                    menu_type: item.menu_type,
                    order: item.order,
                    target: item.target,
                    active: menu_active,
                    show: menu_active,
                    child: []
                  }
                }else{
                  let tmp = {
                    menu_id: item.id,
                    menu_th: item.menu_th,
                    menu_en: item.menu_en,
                    link: item.link,
                    menu_type: item.menu_type,
                    order: item.order,
                    target: item.target,
                    active: menu_active,
                    show: menu_active,
                    child: []
                  };
                  if(menu_index.indexOf(item.parent_menu_id).child){
                    menu[menu_index.indexOf(item.parent_menu_id)].child.push(tmp);
                  }else{
                    menu.forEach((element,menu_index) => {
                      element.child.forEach((item,child_index) => {
                        if(item.menu_id === item.parent_menu_id){
                          menu[menu_index].child[child_index].child.push(tmp);
                        }
                      });
                    });
                  }
                }
            });
            setMenus(menu);
          } catch (err) {
              if(err.response){
                  //Not in 202 response range
                  console.log(err.response.data);
                  console.log(err.response.headers);
                  console.log(err.response.status);
              } else {
                  console.log(`Error: ${err.message}`);
              }
          }
  
          try {
            const response = await api.get('/setting');
            setInit(response.data.results);
            const home_config = JSON.parse(response.data.results.config);
            localStorage.setItem("lannainfo_init",JSON.stringify(response.data.results));
            setHeaderColor(home_config.header_color);
            setBGColor(home_config.bg_color);
            if(home_config.body_font==='Princess Galyani Vadhana IM'){
              setBodyFont("galyani");
            }else if(home_config.body_font==='Kanit'){
              setBodyFont("kanit");
            }else if(home_config.body_font==='Saruns2477'){
              setBodyFont("saruns");
            }else if(home_config.body_font==='TH Sarabun New'){
              setBodyFont("sarabun");
            }else if(home_config.body_font==='Pudgrong'){
              setBodyFont("pudgrong");
            }else{
              setBodyFont("sans-serif");
            }
            
            if(home_config.header_font==='Princess Galyani Vadhana IM'){
                setHeaderFont("galyani !text-5xl");
            }else if(home_config.header_font==='Kanit'){
                setHeaderFont("kanit");
            }else if(home_config.header_font==='TH Sarabun New'){
                setHeaderFont("sarabun");
            }else if(home_config.header_font==='Saruns2477'){
                setHeaderFont("saruns");
            }else if(home_config.header_font==='Pudgrong'){
                setHeaderFont("pudgrong");
            }else{
                setHeaderFont("sans-serif");
            }
            
            // console.log(home_config.header_color);
            // console.log(home_config.bg_color);
          } catch (err) {
              if(err.response){
                  //Not in 202 response range
                  console.log(err.response.data);
                  console.log(err.response.headers);
                  console.log(err.response.status);
              } else {
                  console.log(`Error: ${err.message}`);
              }
          }
        }
        fetchMenus();

        let text_size = cookies.get('text-size');
        setFontSize(text_size);
    },[]);

    window.addEventListener('scroll', (event) => {
      if(header_ref.current){
        if (window.scrollY > 5) {
          header_ref.current.className = layout["drop-shadow"];
        } else {
          header_ref.current.className = layout["shadow-none"];
        }
      }
    });

    const setLanguage = (lang) => {
        setLang(prev => lang);
        localStorage.setItem("lang", lang);
        window.location.reload(false);
    }

    const setFont = (text_size) => {
      setFontSize(prev => text_size);
      cookies.set('text-size', text_size, { path: '/' });
      body_ref.current.ClassName = getTextSize();
    }

    return (
      <div ref={body_ref} className={getTextSize()+' '+body_font}>
      <header ref={header_ref} className={layout["shadow-none"]} style={{backgroundColor: header_color}}>
          {(init.name_th!==undefined)?
          <nav className={layout["nav"]}>
            <div className={layout["nav-container"]}>
                <div className={layout["logo"]}>
                  <div className={layout["logo-img"]}>
                  <a href={process.env.PUBLIC_URL + "/"}><img src={img_url+lang(init.logo_th,init.logo_en)} alt={lang(init.name_th,init.name_en)} height="80" /></a>
                  <div className="header-info">
                    <h3 className={header_font} dangerouslySetInnerHTML={{__html: lang(init.name_th,init.name_en)}}></h3>
                    <p>{lang("สำนักหอสมุด มหาวิทยาลัยเชียงใหม่","Chiang Mai University Library")}</p>
                  </div>
                  </div>
                  <div className={layout["top-nav"]}>
                    <div className={layout["tool"]}>
                      <ul className={layout["language"]}>
                          <li className={language==="th"?layout.active:''}><button onClick={()=>setLanguage("th")}>TH</button></li>
                          <li className={language==="en"?layout.active:''}><button onClick={()=>setLanguage("en")}>EN</button></li>
                      </ul>
                      <ul className={layout["font-size"]}>
                          <li className={font_size==="small"?layout.active:''}><button onClick={()=>setFont("small")}>ก</button></li>
                          <li className={font_size==="normal"?layout.active:''}><button onClick={()=>setFont("normal")}>ก</button></li>
                          <li className={font_size==="large"?layout.active:''}><button onClick={()=>setFont("large")}>ก</button></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <Menu language={language} setLanguage={setLanguage} init={init} layout={layout} header_color={header_color} font_size={font_size} setFont={setFont} />
            </div>
          </nav>
          :''}
      </header>
      {/* <section style={{"background":bg_color}}> */}
          {(init.name_th!==undefined)?
          <Suspense fallback={<Preloader text="" />}>
            <Outlet />
          </Suspense>
          :''}
          {/* <!--begin::Scrolltop Button--> */}
          <ScrollToTop />
          {/* <!--end::Scrolltop Button--> */}
      {/* </section> */}
          {(init.name_th!==undefined)?
      <div className={footer_styles.footer} style={{backgroundColor: bg_color}}>
        <Footer init={init} styles={footer_styles}/>
      </div>
          :''}
      <CookieBanner />
      </div>
    );
}

export default Layout